import styles from './_loader.module.scss';
import { ReactComponent as LoaderLogo } from './loader.svg';

const Loader = () => {
  return (
    <div className={styles.loaderWrap}>
      <div className={styles.loader}>
        <LoaderLogo />
      </div>
    </div>
  );
};

export default Loader;
